'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AllowedUtms = {
  UTM_SOURCE: 'UTM_SOURCE',
  UTM_MEDIUM: 'UTM_MEDIUM'
};

exports.default = AllowedUtms;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.15/js/constants/AllowedUtms.js
// module id = 140
// module chunks = 0